import {all, call, fork, put, select, takeEvery, takeLatest} from 'redux-saga/effects'
import types from 'actions/types'
import {generalError} from 'actions/index'
import {
  addDepartmentFailure,
  addDepartmentSuccess,
  addWorkCentreFailure,
  addWorkCentreSuccess,
  deleteDepartmentFailure,
  deleteDepartmentSuccess,
  deleteWorkCentreFailure,
  deleteWorkCentreSuccess,
  loadDepartmentsFailure,
  loadDepartmentsSuccess,
  loadWorkCentres as loadWorkCentresAction,
  loadWorkCentresFailure,
  loadWorkCentresSuccess,
  updateDepartmentFailure,
  updateDepartmentSuccess,
  updateWorkCentreFailure,
  updateWorkCentreSuccess,
} from 'actions/department'
import {
  getProductionDepartments,
} from 'selectors/jobBoards'
import  {get, isEmpty} from 'lodash'
import {
  DepartmentType,
  WorkCentreStatus,
} from 'helpers/production'
import {selectProductionDepartment} from "actions/production"
import {selectDeliveryDepartment} from "actions/deliveries"
import {getDepartmentsForType} from "selectors/department"

export const departmentFields = {
  default: true,
  hasJobCards: true,
  jobCardsCount: true,
  hasDeliveries: true,
  deliveryCount: true,
}

export const workCentreFields = {
  default: true,
  department: true,
  hasJobCards: true,
  jobCardsCount: true,
  deliveriesSummary: true,
}

export default (api) => {


  function* loadDepartments() {
    try {

      const params = {}

      const response = yield call(api.departments.get, params, departmentFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(loadDepartmentsSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(loadDepartmentsFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* loadWorkCentres() {
    try {

      const params = {}

      const response = yield call(api.workCentres.get, params, workCentreFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(loadWorkCentresSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(loadWorkCentresFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* addDepartment({department}) {
    try {
      const params = {
        name: department.name,
        sortOrder: department.sortOrder,
        departmentType: get(department, 'departmentType', DepartmentType.PRODUCTION),
      }

      const response = yield call(api.departments.add, params, departmentFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const department = data.result[0]
            const departmentId = department.id
            yield put(addDepartmentSuccess(department))
            if (get(department, 'departmentType', DepartmentType.PRODUCTION) === DepartmentType.PRODUCTION) {
              yield put(selectProductionDepartment(departmentId))
            }
            if (get(department, 'departmentType', DepartmentType.PRODUCTION) === DepartmentType.DELIVERY) {
              yield put(selectDeliveryDepartment(departmentId))
            }

          },
          function* onFail(key, message, code) {
            yield put(addDepartmentFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* updateDepartment({department}) {
    try {
      const params = {
        id: department.id,
        name: department.name,
        sortOrder: department.sortOrder,
      }

      const response = yield call(api.departments.update, params, departmentFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(updateDepartmentSuccess(data.result[0]))
          },
          function* onFail(key, message, code) {
            yield put(updateDepartmentFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* deleteDepartment({department, replacementDepartmentId, replacementWorkCentreId}) {
    try {
      const departmentId = department.id
      const params = {
        id: departmentId,
        replacementDepartmentId,
        replacementWorkCentreId,
      }

      const response = yield call(api.departments.delete, params, departmentFields)
      yield api.handleResponse(
          response,
          function* onOk() {
            yield put(deleteDepartmentSuccess({id: departmentId}))
            yield put(loadWorkCentresAction())
            if (get(department, 'departmentType', DepartmentType.PRODUCTION) === DepartmentType.PRODUCTION) {
              const productionDepartments = yield select(state => getProductionDepartments(state))
              yield put(selectProductionDepartment(isEmpty(productionDepartments) ? null : productionDepartments[0].id))
            }
            if (get(department, 'departmentType', DepartmentType.PRODUCTION) === DepartmentType.DELIVERY) {
              const deliveryDepartments = yield select(state => getDepartmentsForType(state, DepartmentType.DELIVERY))
              yield put(selectProductionDepartment(isEmpty(deliveryDepartments) ? null : deliveryDepartments[0].id))
            }
          },
          function* onFail(key, message, code) {
            yield put(deleteDepartmentFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* addWorkCentre({workCentre}) {
    try {

      const params = {
        workCentre: {
          ...workCentre,
          workCentreStatus: WorkCentreStatus.ENABLED,
        },
      }

      const response = yield call(api.workCentres.add, params, workCentreFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(addWorkCentreSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(addWorkCentreFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* updateWorkCentre({workCentre}) {
    try {

      const params = {
        workCentre,
      }

      const response = yield call(api.workCentres.update, params, workCentreFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(updateWorkCentreSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(updateWorkCentreFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* deleteWorkCentre({workCentre, replacementDepartmentId, replacementWorkCentreId}) {
    try {

      const workCentreId = workCentre.id
      const params = {
        id: workCentreId,
        replacementDepartmentId,
        replacementWorkCentreId,
      }

      const response = yield call(api.workCentres.delete, params, workCentreFields)
      yield api.handleResponse(
          response,
          function* onOk() {
            yield put(deleteWorkCentreSuccess({workCentreId}))
            yield put(loadWorkCentresAction())
          },
          function* onFail(key, message, code) {
            yield put(deleteWorkCentreFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* myWatcher() {
    yield all([
      takeLatest(types.DEPARTMENTS_LOAD_ATTEMPT, loadDepartments),
      takeLatest(types.DEPARTMENTS_ADD_ATTEMPT, addDepartment),
      takeEvery(types.DEPARTMENTS_UPDATE_ATTEMPT, updateDepartment),
      takeLatest(types.DEPARTMENTS_DELETE_ATTEMPT, deleteDepartment),

      takeLatest(types.WORK_CENTRES_LOAD_ATTEMPT, loadWorkCentres),
      takeLatest(types.WORK_CENTRES_ADD_ATTEMPT, addWorkCentre),
      takeEvery(types.WORK_CENTRES_UPDATE_ATTEMPT, updateWorkCentre),
      takeLatest(types.WORK_CENTRES_DELETE_ATTEMPT, deleteWorkCentre),
    ])
  }

  function* watcher() {
    yield fork(myWatcher)
  }

  return {
    watcher,
  }
}
